module.exports = __webpack_public_path__ + "img/base-town.c6d582d.png";